export const mockHomeworkSettings: any = {
    id: 1,
    homework_enabled: true,
    homework_price: 100,
    homework_duration: 60,
    reading_enabled: true,
    reading_price: 200,
    reading_duration: 30,
    max_days: 5,
    min_days: 56,
    employee_ids: [],
};
